import React, { lazy } from "react";

import { VIEW_DASHBOARD_PERMISSION } from "constants/permissions";

const DashboardPage = lazy(() => import("./DashboardPage"));

const dashboardRoute = {
  path: "dashboard",
  element: <DashboardPage />,
  root: true,
  permission: VIEW_DASHBOARD_PERMISSION,
};

export default dashboardRoute;
